var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading > 0),expression:"isLoading > 0"}],staticClass:"loading-layer"},[_c('svg',{attrs:{"height":"56","viewBox":"0 0 56 56","width":"72"}},[_c('g',[_c('circle',{attrs:{"cx":"28","cy":"28","id":"spinner","r":"25"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }